import { Fragment } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar } from 'swiper/modules';
import TabItem from './TabItem';
import type { ITabData } from './tabType';

const SwiperTab = ({ data, className }: { data: ITabData[]; className?: string }) => {
  if (!Array.isArray(data) || data?.length === 0) {
    return <Fragment />;
  }

  // <Swiper /> 내에서 unmount 시킴
  return (
    <Swiper modules={[Scrollbar]} slidesPerView="auto" className={`tab swiper-tab ${className || ''}`}>
      {data?.map((v, i) => (
        <SwiperSlide key={v?.key || i}>
          <TabItem data={v} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default SwiperTab;
